import AttributeButton from "components/Button/AttributeButton";
import V2ModalForm from "components/ModalForm/V2ModalForm";
import { UseFormReturn } from "react-hook-form";
import Form from "./Form";
import { meetingTemplateReferenceEventTimingSummary } from "features/Resources/MeetingTemplate/helpers";
import DashedButton from "components/Button/DashedButton";

interface MeetingTimingWithButtonFormProps {
  form: UseFormReturn<any>;
  disabled?: boolean;
}

export default function OccurrenceSelectionFormButton({ form, disabled = false }: MeetingTimingWithButtonFormProps) {
  const { watch } = form;
  const [referenceEvent, offset, offsetUnit] = watch(["referenceEvent", "offset", "offsetUnit"]);

  const timingSummary = meetingTemplateReferenceEventTimingSummary({ referenceEvent, offset, offsetUnit });
  const descriptor = timingSummary ? `Not before ${timingSummary}` : undefined;

  return disabled ? (
    <AttributeButton w="100%" display="flex" justifyContent="flex-start" disabled={disabled}>{descriptor}</AttributeButton>
  ) : (
    <V2ModalForm
      modalHeader=""
      size="lg"
      includeCloseButton={false}
      renderButton={(onOpen) => (
        descriptor ? (
          <AttributeButton w="100%" display="flex" justifyContent="flex-start" disabled={disabled} onClick={onOpen}>{descriptor}</AttributeButton>
        ) : (
          <DashedButton title="Define Occurrence Selection" onClick={onOpen} />
        )
      )}
      renderForm={(onClose) => <Form form={form} onClose={onClose} />}
    />
  );
}

